import customDecodeURIComponent from "./customDecodeURIComponent.js";
const getCookie = (name)=>{
    const result = {};
    document.cookie.split(';').forEach((cookie)=>{
        const values = cookie.trim().match(/(\w+)=(.*)/);
        if (values && name === values[1]) result[values[1]] = values[2];
    });
    return result;
};
const getAll = (_rawCookies)=>{
    const rawCookies = _rawCookies || document.cookie;
    const cookies = {};
    try {
        rawCookies.split(';').forEach((cookie)=>{
            const values = cookie.trim().match(/(\w+)=(.*)/);
            if (values) cookies[values[1].trim()] = customDecodeURIComponent(values[2]);
        });
    } catch (error) {
        console.error('getAll: Error to parse cookies', error);
    }
    return cookies;
};
const setCookie = (name, value, expDays = 1, expDate = '')=>{
    if (!name || !value) return void console.warn('You must pass the first two parameters (name and value) of the cookie');
    const expDateWithDays = new Date();
    const offSet = 24 * expDays * 3600000;
    expDateWithDays.setTime(expDateWithDays.getTime() + offSet);
    document.cookie = `${name}=${value};expires=${expDate || expDateWithDays.toUTCString()};path=/`;
};
const deleteCookie = (name)=>{
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
export { deleteCookie, getAll, getCookie, setCookie };
